/**
 * auto-generated enum by saas-tool
 **/
export enum LOCALE_CATEGORIES {
  ACTION_PLAN = "action_plan",
  ADMIN = "admin",
  AFTER_SIGN_UP = "after_sign_up",
  AI_DEBRIEF = "ai_debrief",
  ANTIBLOCK = "antiblock",
  BOOTCAMP = "bootcamp",
  COACHEES = "coachees",
  COMMUNITY = "community",
  CONFIRM_ACCOUNT = "confirm_account",
  CONTACT_US = "contact_us",
  CONTRACT_HUB_CGU_22_12_16 = "contract_hub_cgu_22_12_16",
  CONTRACT_HUB_CGU_23_03_14 = "contract_hub_cgu_23_03_14",
  CONTRACT_HUB_CGU_23_10_16 = "contract_hub_cgu_23_10_16",
  CONTRACT_HUB_CGU_25_07_02 = "contract_hub_cgu_25_07_02",
  CONTRACT_HUB_LEGAL_23_03_14 = "contract_hub_legal_23_03_14",
  CONTRACT_HUB_LEGAL_25_07_02 = "contract_hub_legal_25_07_02",
  CUSTOMIZE = "customize",
  DEBRIEF_HELPER = "debrief_helper",
  ELEARNING_PROGRAM = "elearning_program",
  ERRORS = "errors",
  FETA = "feta",
  GROUP_TOOLS = "group_tools",
  JOURNEY = "journey",
  LEGAL_MENTIONS_GLOBAL = "legal_mentions_global",
  LEXICON = "lexicon",
  MY_ACCOUNT = "my_account",
  NAVIGATION = "navigation",
  PAGINATION = "pagination",
  RESET_PASSWORD = "reset_password",
  SEND_INVITATION = "send_invitation",
  SIGN_IN = "sign_in",
  SIGN_UP = "sign_up",
  SKILL_DEFINITION = "skill_definition",
  TINGARI_CUSTOMIZATION = "tingari_customization",
  TOS_GLOBAL = "tos_global",
}
